import { render, staticRenderFns } from "./LoansAd.vue?vue&type=template&id=11b609b2&scoped=true&"
import script from "./LoansAd.vue?vue&type=script&lang=js&"
export * from "./LoansAd.vue?vue&type=script&lang=js&"
import style0 from "./LoansAd.vue?vue&type=style&index=0&id=11b609b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b609b2",
  null
  
)

export default component.exports